import { render, staticRenderFns } from "./CoursesOngoing.vue?vue&type=template&id=63661f3a&scoped=true"
import script from "./CoursesOngoing.vue?vue&type=script&lang=js"
export * from "./CoursesOngoing.vue?vue&type=script&lang=js"
import style0 from "./CoursesOngoing.vue?vue&type=style&index=0&id=63661f3a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63661f3a",
  null
  
)

export default component.exports